import { render } from "./HeaderCarouselImageEditModal.vue?vue&type=template&id=4c20ff56&scoped=true"
import script from "./HeaderCarouselImageEditModal.vue?vue&type=script&lang=js"
export * from "./HeaderCarouselImageEditModal.vue?vue&type=script&lang=js"

import "./HeaderCarouselImageEditModal.vue?vue&type=style&index=0&id=4c20ff56&scoped=true&lang=less"
import "./HeaderCarouselImageEditModal.vue?vue&type=style&index=1&id=4c20ff56&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c20ff56"]])

export default __exports__